import * as React from "react";

function SvgIconfeatherChevronRight(props) {
  return (
    <svg width={5.207} height={9.414} {...props}>
      <path
        data-name="Icon feather-chevron-right"
        d="M.707 8.707l4-4-4-4"
        fill="none"
        stroke="#4d4d4d"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgIconfeatherChevronRight;
